import { createStyles, makeStyles } from '@material-ui/core';
import { Colors } from '../../../../../../ui/layout/theme-next';
import { MAX_STATUS_WIDTH, VIEWPORT_PADDING } from '../../helpAgentPanel.constants';

export default makeStyles(theme => createStyles({
  panel: {
    position: 'fixed',
    display: 'none',
    padding: 0,
    margin: 0,
    zIndex: 1400,
    background: 'transparent',
    '&.open': {
      display: 'block',
    },
  },
  status: {
    boxSizing: 'border-box',
    width: `min(${MAX_STATUS_WIDTH}px, calc(100vw - ${VIEWPORT_PADDING * 2}px))`,
    minHeight: 566,
    padding: 32,
    background: Colors.white,
    color: Colors.textBlack,
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)',
    display: 'grid',
    placeItems: 'center',
    '&:empty': {
      display: 'none',
    },
  },
  '@keyframes helpAgentStatusSpin': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
  '@global': {
    '.help-agent-panel-status .help-agent-host-shell': {
      display: 'grid',
      justifyItems: 'center',
      gap: 14,
      width: '100%',
      maxWidth: 300,
      textAlign: 'center',
    },
    '.help-agent-panel-status .help-agent-host-loading': {
      display: 'grid',
      justifyItems: 'center',
      gap: 14,
    },
    '.help-agent-panel-status .help-agent-host-error': {
      display: 'grid',
      justifyItems: 'center',
      gap: 14,
    },
    '.help-agent-panel-status .help-agent-host-loading-ring': {
      width: 56,
      height: 56,
      boxSizing: 'border-box',
      display: 'grid',
      placeItems: 'center',
      border: `3px solid ${Colors.primaryHighlight}`,
      borderTopColor: Colors.primary,
      borderRightColor: Colors.secondary,
      borderRadius: '50%',
      animation: '$helpAgentStatusSpin 1.2s linear infinite',
    },
    '.help-agent-panel-status .help-agent-host-error-icon': {
      width: 56,
      height: 56,
      display: 'grid',
      placeItems: 'center',
      borderRadius: '50%',
      background: Colors.errorHighlight,
      color: Colors.error,
      fontSize: 28,
      fontWeight: 600,
    },
    '.help-agent-panel-status .help-agent-host-status-title': {
      fontSize: 18,
      fontWeight: 600,
      lineHeight: 1.3,
    },
    '.help-agent-panel-status .help-agent-host-status-message': {
      color: Colors.textGray,
      fontSize: 14,
      lineHeight: 1.5,
    },
    '.help-agent-panel-status .help-agent-host-retry': {
      minWidth: 112,
      padding: '10px 18px',
      border: 0,
      borderRadius: 999,
      background: Colors.primary,
      color: Colors.white,
      cursor: 'pointer',
      font: 'inherit',
      fontWeight: 600,
      '&:hover': {
        background: Colors.primaryDark,
      },
      '&:focus-visible': {
        outline: `2px solid ${Colors.secondary}`,
        outlineOffset: 3,
      },
    },
    '.help-agent-panel-status[data-state="loading"] .help-agent-host-loading': {
      visibility: 'visible',
      position: 'static',
    },
    '.help-agent-panel-status[data-state="loading"] .help-agent-host-error': {
      visibility: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
    },
    '.help-agent-panel-status[data-state="loading"] .help-agent-host-loading-ring': {
      animationPlayState: 'running',
    },
    '.help-agent-panel-status[data-state="error"] .help-agent-host-loading': {
      visibility: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
    },
    '.help-agent-panel-status[data-state="error"] .help-agent-host-error': {
      visibility: 'visible',
      position: 'static',
      display: 'grid',
    },
    '.help-agent-panel-status[data-state="error"] .help-agent-host-loading-ring': {
      animationPlayState: 'paused',
    },
    '@media (prefers-reduced-motion: reduce)': {
      '.help-agent-panel-status .help-agent-host-loading-ring': {
        animation: 'none !important',
      },
    },
  },
}));
